import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { ColorOptions } from '@maps/components/color-swatch-color-map';
import styles from './color-swatch.module.scss';

interface ColorSwatchInterface {
  checked: boolean;
  label: React.JSX.Element | string;
  htmlId: string;
  swatchColor?: ColorOptions;
  onChange?: (event: Event) => void;
}

type ColorSwatchProps = ColorSwatchInterface & Omit<React.HTMLProps<HTMLDivElement>, 'label' | 'color'>;

const ColorSwatch: React.FC<ColorSwatchProps> = (props) => {
  const { label, checked = false, htmlId, swatchColor, onChange, className, ...rest } = props;

  const [checkedState, setCheckedState] = useState(checked);

  const handleChange = (event) => {
    onChange(event);
    setCheckedState(!checkedState);
  };

  useEffect(() => {
    setCheckedState(checked);
  }, [checked]);

  const hasBorder =
    swatchColor &&
    swatchColor.hexadecimal &&
    ['#fff', '#ffffff', 'white'].includes(swatchColor.hexadecimal.toLowerCase());

  return (
    <div
      className={clsx(styles.colorSwatch__container)}
      key={htmlId}
      {...rest}
    >
      <input
        type="checkbox"
        id={htmlId}
        hidden
        className={styles.colorSwatch__checkbox}
        checked={checkedState}
        onChange={(e) => {
          handleChange(e);
        }}
      />
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <label
        htmlFor={htmlId}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- for accessibility
        tabIndex={0}
        className={clsx(styles.colorSwatch__label, {
          [styles['colorSwatch__label--hasBorder']]: hasBorder,
          [styles['colorSwatch__label--isUnset']]: swatchColor.noColor,
        })}
        style={{
          ...(swatchColor && !swatchColor.assetUrl ? { backgroundColor: swatchColor.hexadecimal } : {}),
        }}
        onKeyPress={(e) => {
          if (e.code === 'Space' || e.code === 'Enter') {
            e.preventDefault();
            handleChange(e);
          }
        }}
      >
        {swatchColor && swatchColor.assetUrl && (
          <img
            height={22}
            width={22}
            alt={typeof label === 'string' ? label : ''}
            src={swatchColor.assetUrl}
          />
        )}
      </label>
    </div>
  );
};

export default ColorSwatch;
